module.exports = __webpack_public_path__ + "img/packages.57c87963.jpg";